import React from "react";
import Navbar from "../components/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./Packages.css";

const MyPackage = ({ packageId }) => {

  let hasActiveFreePackage = false;
  if (packageId == 1183) {
    hasActiveFreePackage = true;
  }

  const packages = [
    {
      id: 1123,
      title: "One Time Instant Doctors",
      location: "Pakistan",
      originalPrice: "Rs. 1500",
      discountedPrice: "Rs. 300 only",
      discount: "80% Off",
      features: [
        { text: "Video Call to Doctor", isAvailable: true },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "One-time Payment", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: false },
        { text: "Maintains Full Medical History", isAvailable: false },
      ],
    },
    {
      id: 1124,
      title: "WEBDOC Instant Doctors",
      description: "(Unlimited Calls)",
      originalPrice: "Rs. 4000",
      discountedPrice: "Rs. 999/- only",
      discount: "75% Off",
      features: [
        { text: "Video Call to Doctor Anytime", isAvailable: true },
        { text: "Maintains Full Medical History", isAvailable: true },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "Monthly Subscription", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: true },
      ],
    },
    {
      id: 1126,
      title: "One Time Instant Doctors for Expats",
      originalPrice: "$25 per call",
      discountedPrice: "$10 per call",
      discount: "60% Off",
      features: [
        { text: "Video Call to Doctor", isAvailable: true },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "One-time Payment", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: false },
        { text: "Maintains Full Medical History", isAvailable: false },
      ],
    },
    {
      id: 1125,
      title: "WEBDOC Instant Doctors",
      description: "(Unlimited Calls) for Expats",
      originalPrice: "$35 a month",
      discountedPrice: "$14 monthly",
      discount: "60% Off",
      features: [
        { text: "Video Call to Doctor anytime", isAvailable: true },
        { text: "Maintains Full Medical History", isAvailable: true },
        { text: "Instant Prescription via SMS and App", isAvailable: true },
        { text: "Monthly Subscription", isAvailable: true },
        { text: "Unlimited Video Calls", isAvailable: true },
      ],
    },  ];

  // Define the free package for first 100 users
  const freePackage = {
    id: 'free',
    title: "Free Instant Doctor Consultation",
    description: "(Limited Time Offer - First 100 Users)",
    originalPrice: "Rs. 1500",
    discountedPrice: "Free",
    discount: "100% Off",
    features: [
      { text: "Video Call to Doctor", isAvailable: true },
      { text: "Instant Prescription via SMS and App", isAvailable: true },
      { text: "One-time Free Consultation", isAvailable: true },
      { text: "Unlimited Video Calls", isAvailable: false },
      { text: "Maintains Full Medical History", isAvailable: false },
    ],
  };

  // Find the package that matches the provided packageId
  const selectedPackage = packages.find((pkg) => pkg.id === packageId);

  return (
    <>
      <Navbar />
      <div className="package-page">
        <h4 className="page-title"></h4>        <div className="package-list ">
          {selectedPackage ? (
            <div
              key={selectedPackage.id}
              className={`package-card col-md-4 col-sm-12 ${
                selectedPackage.recommended ? "recommended-package" : ""
              }`}
            >
              <div className="recommended-ribbon-green">Active</div>

              <div className="ribbon">
                <span>{selectedPackage.discount}</span>
              </div>
              <p className="package-title">{selectedPackage.title}</p>
              <div className="price">
                <span className="original-price">
                  {selectedPackage.originalPrice}
                </span>
                <span className="discounted-price">
                  {selectedPackage.discountedPrice}
                </span>
              </div>
              {selectedPackage.description && <p className="package-description">{selectedPackage.description}</p>}
              <ul className="features-list">
                {selectedPackage.features.map((feature, i) => (
                  <li key={i} className="feature-item">
                    <FontAwesomeIcon
                      icon={feature.isAvailable ? faCheckCircle : faTimesCircle}
                      className={`feature-icon ${
                        feature.isAvailable ? "" : "feature-icon-cross"
                      }`}
                    />
                    {feature.text}
                  </li>
                ))}
              </ul>
            </div>
          ) : hasActiveFreePackage ? (
            <div className="package-card col-md-4 col-sm-12">
              <div className="recommended-ribbon-green">Active</div>

              <div className="ribbon">
                <span>{freePackage.discount}</span>
              </div>
              <p className="package-title mt-5">{freePackage.title}</p>
              <div className="price">
                <span className="original-price">
                  {freePackage.originalPrice}
                </span>
                <span className="discounted-price">
                  {freePackage.discountedPrice}
                </span>
              </div>
              {freePackage.description && <p className="package-description">{freePackage.description}</p>}
              <ul className="features-list">
                {freePackage.features.map((feature, i) => (
                  <li key={i} className="feature-item">
                    <FontAwesomeIcon
                      icon={feature.isAvailable ? faCheckCircle : faTimesCircle}
                      className={`feature-icon ${
                        feature.isAvailable ? "" : "feature-icon-cross"
                      }`}
                    />
                    {feature.text}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <p>No package found.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default MyPackage;